import type { User } from '../users';

export function isShopifyBilledUser(
  user: Pick<User, 'signup_source'>,
): boolean {
  return user.signup_source === 'shopify';
}
